import { render, staticRenderFns } from "./modal-bom.vue?vue&type=template&id=ecff0cf6&"
import script from "./modal-bom.vue?vue&type=script&lang=js&"
export * from "./modal-bom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports